import { CARD_CLASS_NAMES } from "./const";
import { CardProps } from "./type";

export const Card = ({ colorType = "default", onClick, children }: CardProps) => (
  <article onClick={onClick} className={CARD_CLASS_NAMES({ colorType, clickable: !!onClick })}>
    {children}
  </article>
);
